import { render, staticRenderFns } from "./VPage.vue?vue&type=template&id=6f2eb3a6&"
import script from "./VPage.vue?vue&type=script&lang=js&"
export * from "./VPage.vue?vue&type=script&lang=js&"
import style0 from "./VPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports